// extracted by mini-css-extract-plugin
export var container = "_ck-0";
export var icon = "_ck-1";
export var text = "_ck-2";